module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ClanInfoPanel/images/elo-icon-6.e712f727.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ClanInfoPanel/images/elo-icon-6.png
// module id = 3265
// module chunks = 11